import { render, staticRenderFns } from "./CommunicationBotsContainer.vue?vue&type=template&id=4222785c&"
import script from "./CommunicationBotsContainer.vue?vue&type=script&lang=js&"
export * from "./CommunicationBotsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports